import axios from 'axios';
// import { format } from 'date-fns';
import { getField, updateField } from 'vuex-map-fields';

export default {
  namespaced: true,
  state: {
    nps: null,
    percentilNps: {
      promoters: 0,
      passive: 0,
      detractors: 0,
    },
    grades: {
      0: 0,
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 0,
      8: 0,
      9: 0,
      10: 0,
    },
    answersByPhone: {},
    answersByEmail: {},
    answersByManual: {},
    answersByLinkWppWppWidgetQrCode: {},
    amountAnswers: null,
    amountClients: 0,
    amountInvites: -1,
  },

  mutations: {
    updateField,
    GET_NPS(state, payload) {
      if (payload) {
        state.nps = payload.nps ? payload.nps : 0;
      }
    },
    GET_PERCENTIL(state, payload) {
      if (payload) {
        state.percentilNps = {
          promoters: payload.promoters ? payload.promoters : 0,
          passive: payload.passive ? payload.passive : 0,
          detractors: payload.detractors ? payload.detractors : 0,
        };
      }
    },
    GET_GRADES(state, payload) {
      if (payload) {
        state.grades = { ...state.grades, ...payload.grades };
      }
    },
    SET_GRADES(state, payload) {
      state.grades = payload;
    },
    SET_PERCENTIL(state, payload) {
      state.percentilNps = {
        promoters: payload.promoters ? payload.promoters : 0,
        passive: payload.passive ? payload.passive : 0,
        detractors: payload.detractors ? payload.detractors : 0,
      };
    },
    SET_ANSWERS_BY_CHANNEL(state, payload) {
      state.answersByPhone = payload.sms;
      state.answersByEmail = payload.email;
      state.answersByManual = payload.manual;
      state.answersByLinkWppWppWidgetQrCode = payload.linkWppWidgetQrCode;
    },
    SET_AMOUNT_ANSWERS(state, payload) {
      state.amountAnswers = payload.answers;
    },
    SET_AMOUNT_CLIENTS(state, payload) {
      state.amountClients = payload.clients;
    },
    SET_AMOUNT_INVITES(state, payload) {
      state.amountInvites = payload.invites;
    },
  },

  actions: {
    async getMetricValue({ commit }, obj) {
      const res = await axios.get(
        `${process.env.API_ROOT}/metrics/${obj.companyId}`,
        {
          headers: { 'x-access-token': obj.token, 'Cache-Control': 'no-cache' },
          params: {
            actionId: obj.actionId,
            ih1: obj.ih1,
            ih2: obj.ih2,
            startDate: obj.startDate,
            endDate: obj.endDate,
            metric: obj.metric,
            groupId: obj.groupId,
            branchGroup: obj.branchGroup,
            allBranches: obj.allBranches,
            indicator: obj.indicator,
            indicatorValue: obj.indicatorValue,
            indicatorRange: obj.indicatorRange,
            period: obj.period,
          },
        },
      );
      commit('GET_NPS', res.data);
      commit('GET_GRADES', res.data);
      commit('GET_PERCENTIL', res.data);
      return res.data;
    },
    async getNpsByDate({ commit }, obj) {
      const res = await axios.get(`${process.env.API_ROOT}/reports/nps`, {
        headers: { 'x-access-token': obj.token },
        params: {
          companyId: obj.companyId,
          actionId: obj.actionId,
          startDate: obj.startDate,
          endDate: obj.endDate,
          metric: obj.metric,
          groupId: obj.groupId,
        },
      });
      commit('GET_NPS', res.data);
    },
    async getGradesByDate({ commit }, obj) {
      const res = await axios.get(`${process.env.API_ROOT}/reports/grades`, {
        headers: { 'x-access-token': obj.token },
        params: {
          companyId: obj.companyId,
          actionId: obj.actionId,
          startDate: obj.startDate,
          endDate: obj.endDate,
          metric: obj.metric,
        },
      });
      commit('SET_GRADES', res.data);
    },
    async setPercentilByDate({ commit }, obj) {
      const res = await axios.get(
        `${process.env.API_ROOT}/reports/percentil-nps`,
        {
          headers: { 'x-access-token': obj.token },
          params: {
            companyId: obj.companyId,
            actionId: obj.actionId,
            startDate: obj.startDate,
            endDate: obj.endDate,
            metric: obj.metric,
          },
        },
      );
      commit('SET_PERCENTIL', res.data);
    },
    async setAnswersByChannel({ commit }, obj) {
      const res = await axios.get(
        `${process.env.API_ROOT}/reports/answer-by-channel`,
        {
          headers: { 'x-access-token': obj.token },
          params: {
            companyId: obj.companyId,
            actionId: obj.actionId,
            startDate: obj.startDate,
            endDate: obj.endDate,
            ih1: obj.ih1,
            ih2: obj.ih2,
            metric: obj.metric,
            groupId: obj.groupId,
            indicator: obj.indicator,
            indicatorValue: obj.indicatorValue,
            indicatorRange: obj.indicatorRange,
            period: obj.period,
          },
        },
      );
      commit('SET_ANSWERS_BY_CHANNEL', res.data);
    },
    async setAmountAnswers({ commit }, obj) {
      const res = await axios.get(
        `${process.env.API_ROOT}/reports/count-documents`,
        {
          headers: { 'x-access-token': obj.token },
          params: {
            companyId: obj.companyId,
            actionId: obj.actionId,
            startDate: obj.startDate,
            endDate: obj.endDate,
            ih1: obj.ih1,
            ih2: obj.ih2,
            metric: obj.metric,
            groupId: obj.groupId,
            indicator: obj.indicator,
            indicatorValue: obj.indicatorValue,
            indicatorRange: obj.indicatorRange,
            period: obj.period,
          },
        },
      );
      commit('SET_AMOUNT_ANSWERS', res.data);
    },
    async setAmountClients({ commit }, obj) {
      const res = await axios.get(
        `${process.env.API_ROOT}/reports/count-clients`,
        {
          headers: { 'x-access-token': obj.token },
          params: {
            companyId: obj.companyId,
            actionId: obj.actionId,
            startDate: obj.startDate,
            endDate: obj.endDate,
            ih1: obj.ih1,
            ih2: obj.ih2,
            metric: obj.metric,
            groupId: obj.groupId,
            indicator: obj.indicator,
            indicatorValue: obj.indicatorValue,
            indicatorRange: obj.indicatorRange,
            period: obj.period,
          },
        },
      );
      commit('SET_AMOUNT_CLIENTS', res.data);
    },
    async setAmountInvites({ commit }, obj) {
      const res = await axios.get(
        `${process.env.API_ROOT}/reports/count-invites`,
        {
          headers: { 'x-access-token': obj.token },
          params: {
            companyId: obj.companyId,
            actionId: obj.actionId,
            startDate: obj.startDate,
            endDate: obj.endDate,
            ih1: obj.ih1,
            ih2: obj.ih2,
            metric: obj.metric,
            groupId: obj.groupId,
            indicator: obj.indicator,
            indicatorValue: obj.indicatorValue,
            indicatorRange: obj.indicatorRange,
            period: obj.period,
          },
        },
      );
      commit('SET_AMOUNT_INVITES', res.data);
    },
  },

  getters: { getField },
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/index.js